import { Button, ButtonToolbar } from "react-bootstrap";
import TruncatedList from "../../../../components/TruncatedList";
import { useHashUnsubscriber } from "../../hooks";
import { RenderWhen } from "../../../../components";

type HashUnsubscriberProps = {
  hashes: Array<string>;
  onClose: () => void;
};

const HashUnsubscriber = ({ hashes, onClose }: HashUnsubscriberProps) => {
  const {
    unsubscribeAction,
    cappedHashes,
    dialogMessage,
    isHashListOverLimit
  } = useHashUnsubscriber(hashes, onClose);

  return (
    <div>
      <RenderWhen condition={isHashListOverLimit}>
        <p
          className="mb-10 fw-bold"
          data-testid="hash_unsubscribe_limit_message"
        >
          Unsubscribe action supports up to 100 hashes. Your list of hashes was
          shortened to the first 100 hashes you selected.
        </p>
      </RenderWhen>

      <p className="mb-10" data-testid="hash_unsubscribe_message">
        {dialogMessage}
      </p>
      <TruncatedList items={cappedHashes} visibleItemsCount={10}>
        {({ visibleItems, more, getHashList }) => (
          <div>
            <ul>
              {visibleItems.map((item: string) => (
                <li
                  key={item}
                  data-testid={`hash_unsubscribe_list_item_${item}`}
                >
                  {item}
                </li>
              ))}
            </ul>
            {more && (
              <div style={{ marginTop: "10px" }}>
                <a
                  href="#"
                  onClick={e => {
                    e.preventDefault();
                    getHashList(true);
                  }}
                  className="u-link-underlined"
                  data-testid="hash_unsubscribe_list_view_all"
                >
                  View All
                </a>
              </div>
            )}
          </div>
        )}
      </TruncatedList>

      <ButtonToolbar className="mt-25">
        <div className="pull-right">
          <Button
            id="unsubscribe_button"
            type="button"
            variant="prompt-secondary"
            onClick={() => unsubscribeAction()}
            className="pull-left"
            data-testid="hash_unsubscribe_button"
          >
            Unsubscribe
          </Button>
          <Button
            id="cancel_unsubscribe_button"
            type="button"
            variant="prompt-primary"
            onClick={onClose}
            data-testid="hash_unsubscribe_cancel_button"
          >
            Cancel
          </Button>
        </div>
      </ButtonToolbar>
    </div>
  );
};

export default HashUnsubscriber;
